import React, {useEffect, useState} from "react";
import styled from "styled-components";
// Components
import CarpetCard from "../Carpet/CarpetCard"; // Import CarpetBox
import FullButton from "../Buttons/FullButton";
// Assets

import {fetchCarpetsFromDynamoDB} from "../../aws/DynamoDB";
import {useNavigate} from "react-router-dom";

export default function HomeCarpets() {
  const [carpets, setCarpets] = useState([]);
  const navigate = useNavigate();

  const fetchCarpetsHome = async () => {
    try {
      const data = await fetchCarpetsFromDynamoDB()
        setCarpets(data);
    } catch (error) {
      console.error("Failed to fetch carpets:", error);
    }
  };  // Reset pagination and fetch when search, filters, or sort changes.
  useEffect(() => {
    fetchCarpetsHome();
  }, []);
  return (
      <Wrapper id="projects">
        <div className="whiteBg">
          <div className="container">
            <HeaderInfo>
              <h1 className="font40 extraBold">Unsere Teppich-Kollektionen</h1>
              <p className="font18">
                Entdecken Sie unsere hochwertigen Teppichkollektionen. Stilvoll, bequem und perfekt für jedes Zuhause.
                <br />
                Lassen Sie sich inspirieren und finden Sie den Teppich, der zu Ihnen passt.
              </p>
            </HeaderInfo>

            <CarpetGrid>
              {carpets.map((carpet) => (
                  <CarpetCard key={carpet.id} carpet={carpet}/>
              ))}
            </CarpetGrid>

            <div className="row flexCenter">
              <div style={{ margin: "50px 0", width: "200px" }}>
                <FullButton title="Alle Teppiche" action={() =>     navigate(`/carpets`)} />
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  
`;

const HeaderInfo = styled.div`
  margin-bottom: 20px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const CarpetGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  justify-items: center;
`;

